import { render, staticRenderFns } from "./feeBill.vue?vue&type=template&id=18857544&scoped=true&"
import script from "./feeBill.vue?vue&type=script&lang=js&"
export * from "./feeBill.vue?vue&type=script&lang=js&"
import style0 from "./feeBill.vue?vue&type=style&index=0&id=18857544&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18857544",
  null
  
)

export default component.exports